import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';
import NewHeart from '@spa/shared/svg/new-heart';
import { WishlistContext } from '@spa/shared/contexts/wishlist';
import { WISHLIST_ACTIONS } from '@spa/shared/constants/wishlistActions';

const AddToWishList = ({ offerId, sendWishlistClickEvent, handleWishlistClick, isOfferOnWishlist }) => {
  const { addToWishlist, removeFromWishlist, isOnWishlist } = useContext(WishlistContext) || {};
  const [isWishlistButtonActive, setIsWishlistButtonActive] = useState(isOfferOnWishlist || isOnWishlist(offerId));

  const handleWishlistButtonClick = e => {
    if (handleWishlistClick) {
      handleWishlistClick(e, offerId);

      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const hasSucceeded = isWishlistButtonActive ? removeFromWishlist(offerId) : addToWishlist(offerId);
    if (!hasSucceeded) {
      return;
    }

    setIsWishlistButtonActive(!isWishlistButtonActive);

    if (sendWishlistClickEvent) {
      sendWishlistClickEvent(isWishlistButtonActive ? WISHLIST_ACTIONS.REMOVE : WISHLIST_ACTIONS.ADD);
    }
  };

  useEffect(() => {
    if (isWishlistButtonActive === isOnWishlist) {
      return;
    }

    setIsWishlistButtonActive(isOfferOnWishlist || isOnWishlist(offerId));
  }, [isOfferOnWishlist, isOnWishlist]);

  return (
    <Wrapper>
      <NewHeart className="wishlist-button" active={isWishlistButtonActive} onClick={handleWishlistButtonClick} />
    </Wrapper>
  );
};

AddToWishList.propTypes = {
  offerId: PropTypes.string,
  sendWishlistClickEvent: PropTypes.func,
  handleWishlistClick: PropTypes.func,
  isOfferOnWishlist: PropTypes.bool
};

export default AddToWishList;
